__turbopack_context__.v({
  "ListPreviewBlock": "ListPreviewBlock-module__a-mF3W__ListPreviewBlock",
  "ListPreviewBlock__ListItem": "ListPreviewBlock-module__a-mF3W__ListPreviewBlock__ListItem",
  "text-center": "ListPreviewBlock-module__a-mF3W__text-center",
  "text-left": "ListPreviewBlock-module__a-mF3W__text-left",
  "text-right": "ListPreviewBlock-module__a-mF3W__text-right",
});
